export interface IconMapping {
  [key: string]: string;
}

export const iconMappings: IconMapping = {
  // Choice icons
  skills: '/assets/images/icons/icn_choice_skills.svg',
  interests: '/assets/images/icons/icn_choice_interests.svg',
  values: '/assets/images/icons/icn_choice_values.svg',
  lifestyle: '/assets/images/icons/icn_choice_lifestyle.svg',

  // Action icons
  checkmark: '/assets/images/icons/checkmark.svg',
  uncheckmark: '/assets/images/icons/uncheckmark.svg',
  'delete-left': '/assets/images/icons/delete-left.svg',
  alert: '/assets/images/icons/alert.svg',
  'close-blue': '/assets/images/icons/close-blue.svg',
  'close-white': '/assets/images/icons/close-white.svg',
  'arrow-right': '/assets/images/icons/arrow-right.svg',
  'search-icon': '/assets/images/icons/search-24px.svg',
  'warning-circle': '/assets/images/icons/warning-circle.svg',
  'warning-triangle': '/assets/images/icons/warning.svg',
  'warning-triangle-outline': '/assets/images/icons/warning-outline.svg',
  'arrow-line-right': '/assets/images/icons/arrow-line-right.svg',
  'share-square': '/assets/images/icons/share-square.svg',

  // Value icons
  achievement: '/assets/images/values-compatibility/award.svg',
  recognition: '/assets/images/values-compatibility/badge.svg',
  'working conditions':
    '/assets/images/values-compatibility/office-building.svg',
  support: '/assets/images/values-compatibility/agreement.svg',
  relationships: '/assets/images/values-compatibility/neural.svg',
  independence: '/assets/images/values-compatibility/user.svg',
  unknown: '/assets/images/values-compatibility/unknown.svg',

  // Blue value icons
  'achievement-blue': '/assets/images/values-compatibility/award-blue.svg',
  'recognition-blue': '/assets/images/values-compatibility/badge-blue.svg',
  'working conditions-blue':
    '/assets/images/values-compatibility/office-building-blue.svg',
  'support-blue': '/assets/images/values-compatibility/agreement-blue.svg',
  'relationships-blue': '/assets/images/values-compatibility/neural-blue.svg',
  'independence-blue': '/assets/images/values-compatibility/user-blue.svg',

  // Other icons
  'counselor-resources-blue':
    '/assets/images/icons/counselor-resources-blue.svg',
  'briefcase-blank': '/assets/images/icons/briefcase-blank.svg',
  'graduation-cap': '/assets/images/icons/graduation-cap.svg',
  'share-nodes': '/assets/images/icons/share-nodes.svg',
  program: '/assets/images/icons/program.svg',
  computer: '/assets/images/icons/computer.svg',
  'unlock-blue': '/assets/images/icons/unlock-blue.svg',
  award: '/assets/images/icons/award.svg',
  link: '/assets/images/icons/link.svg',
  google: '/assets/images/icons/google.svg',
  linkedin: '/assets/images/icons/linkedIn.svg',
  'chat-via': '/assets/images/icons/chat-via.svg',

  'thumbs-up': '/assets/images/tutorial/thumbs-up.svg',
  'thumbs-up-fill': '/assets/images/tutorial/thumbs-up-fill.svg',
  'thumbs-down': '/assets/images/tutorial/thumbs-down.svg',
  'thumbs-down-fill': '/assets/images/tutorial/thumbs-down-fill.svg',
  pathway: '/assets/images/pathway/pathway-icon.svg',
  dashboard: '/assets/images/analytics/dashboard-icon.svg',

  'chat-loading': '/assets/images/chat-gpt/chat-loading.svg',
  'ask-via': '/assets/images/chat-gpt/ask-via.svg',
  'ask-via-light': '/assets/images/chat-gpt/ask-via-light.svg',

  'via-insight': '/assets/images/goal/ai-insight-summary.svg',
  career: '/assets/images/goal/career.svg',
  academic: '/assets/images/goal/academic.svg',
  compatibility: '/assets/images/goal/compatibility.svg',
  experience: '/assets/images/goal/experience.svg',
  benefit: '/assets/images/goal/benefit.svg',
  constraints: '/assets/images/goal/constraints.svg',
  'current-stage': '/assets/images/goal/current-stage.svg',
  decision: '/assets/images/goal/decision.svg',
  funding: '/assets/images/goal/funding.svg',
  interest: '/assets/images/goal/interest.svg',
  'lifestyle-preferences': '/assets/images/goal/lifestyle.svg',
  location: '/assets/images/goal/location.svg',
  motivations: '/assets/images/goal/motivations.svg',
  supports: '/assets/images/goal/supports.svg',
  'goal-values': '/assets/images/goal/values.svg',
  'user-circle': '/assets/images/goal/user-circle.svg',
  'infra-circle': '/assets/images/goal/infra-circle.svg',
  'all-matched': '/assets/images/connect/all-matched.svg',
  'custom-setting': '/assets/images/connect/custom-org.svg',
  'connect-icon': '/assets/images/goal/connect-icon.svg',
  bullhorn: '/assets/images/connect/bullhorn.svg',
  'check-circle-outline': '/assets/images/connect/check-circle-outline.svg',
  'handshake-outline': '/assets/images/connect/handshake-outline.svg',
  'handshake-icon': '/assets/images/connect/handshake.svg',
  'connect-success': '/assets/images/connect/connect-success.svg',
  star: '/assets/images/connect/star.svg',
  'shield-halve': '/assets/images/connect/shield-halve.svg'
};
